import { render, staticRenderFns } from "./shortvideo.vue?vue&type=template&id=69d53d9a&scoped=true"
import script from "./shortvideo.vue?vue&type=script&lang=js"
export * from "./shortvideo.vue?vue&type=script&lang=js"
import style0 from "./shortvideo.vue?vue&type=style&index=0&id=69d53d9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d53d9a",
  null
  
)

export default component.exports